import React, { useState, useEffect } from "react";
import * as XLSX from 'xlsx';
import {
  useForm,
  FormProvider
} from "react-hook-form";
import { useHistory } from "react-router-dom";
import { DropzoneDialog } from "material-ui-dropzone";
//Material-UI
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import LinearProgress from '@material-ui/core/LinearProgress';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { BoxTemplate1 } from "../../stories/Box";
//Component
import { BaseContainer } from "../../stories/base-container";
import FormInput from "./../../stories/hook-controls/input";
import MuiSelect from "./../../stories/hook-controls/select";
//Function
import { setDataToFormHookV2, isEmptyStr } from "../../utils/common-function";
import { Upload } from "./api";
import { GetListTopicType } from "./api";
import { GetListEncryptMap } from "./api";
import { GetListHost } from "./api";
import * as alertDialog from "./../../utils/alert";

const { log: c } = console;

function UploadScreen() {
  const methods = useForm();
  const { setValue, getValues, setError, clearErrors, errors } = methods;

  const [open, setOpen] = useState(false);

  const [file, setfile] = useState([]);
  const [listColumn, setListColumn] = useState([]);

  const [listTopicType, setListTopic] = useState([]);
  const [topic, setTopic] = useState('');

  const [listEncryptMap, setListEncryptMap] = useState([]);
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const [listHost, setListHost] = useState([]);
  const [hostKey, setHostKey] = useState('');
  //--------
  useEffect(() => {
    const fetch = async () => {
      let listTopicType = await GetListTopicType();
      setListTopic(listTopicType);

      let listEncryptMap = await GetListEncryptMap();
      setListEncryptMap(listEncryptMap);

      let listHost = await GetListHost();
      setListHost(listHost);
    };
    fetch();
  }, []);

  useEffect(() => {
    setValue("FILE_NAME", file?.path);
  }, [file, setValue]);
  async function upload(files = []) {
    setfile(files[0]);
    handleFileUpload(files[0]);
  }

  // handle file upload
  const handleFileUpload = (files) => {
    if (!files) return null;
    const reader = new FileReader();
    reader.onload = (evt) => {
      /* Parse data */
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: 'binary' });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array to arrays */
      const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });
      /* Split to string */
      const dataStringLines = data.split(/\r\n|\n/);
      /* Get First Row */
      const headers = dataStringLines[0].split(/,(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/);
      /* Get Column headers */
      var i = 1;
      const listColumn = headers.map((c) => ({
        COLUMN : c,
        IS_ENCRYPT : true,
        ENCRYPT_ID : '',
        col : i++
      }));
      //console.log(listColumn);
      setListColumn(listColumn);
    };
    reader.readAsBinaryString(files);
  }

  //Event
  const handleHostChange = (event) => {
    //console.log(event.target);
    setHostKey(event.target.value);
  };
  const handleTopicChange = (event) => {
    setTopic(event.target.value);
  };
  const handleChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...listColumn];
    list[index][name] = value;
    setListColumn(list);
  };
  // const handleRemoveClick = index => {
  //   const list = [...columsList];
  //   list.splice(index, 1);
  //   setListColumn(list);
  // };
  // const handleAddClick = () => {
  //   setListColumn([...columsList, { COLUMN: '', ENCRYPT_ID:'', IS_ENCRYPT: true }]);
  // };

  // Function
  async function Submit() {
    clearErrors("HOST_NAME");
    clearErrors("TOPIC_ID");

    if (hostKey === "") {
      setError("HOST_NAME", {
        type: "manual",
        message: "The Host Name field is required",
      });
      return;
    }

    if (!(parseInt(topic) > 0)) {
      setError("TOPIC_ID", {
        type: "manual",
        message: "The Load Topic field is required",
      });
      return;
    }

    let columnMap = listColumn.map((item, i) => {
      if (isEmptyStr(item.ENCRYPT_ID.toString())) {
        return {
          COLUMN: item.COLUMN,
          IS_ENCRYPT: false,
          ENCRYPT_ID: NaN,
          COL_INDEX: item.col,
        };
      }
      else {
        return {
          COLUMN: item.COLUMN,
          IS_ENCRYPT: item.IS_ENCRYPT,
          ENCRYPT_ID: parseInt(item.ENCRYPT_ID),
          COL_INDEX: item.col,
        };
      }
    });
    
    //console.log(columnMap);

    let form = new FormData();
    let data = getValues();
    data.TOPIC_ID = parseInt(topic)
    data.HOST_KEY= hostKey;
    console.log(data);
    form.append("file", file);
    form.append("info", JSON.stringify(data));
    form.append("columnMap", JSON.stringify(columnMap));

    if (!loading) {
      setLoading(true);
    }

    let res = await Upload(form);
    setLoading(false);
    //console.log(res);
    if(res?.ResultCode === 10){
       history.push("/TextLoader");
    }
    else{
      alertDialog.ErrorDialog("Error : "+res.Message);
    }
  }

  const CloseScreen = () => {
    history.push("/TextLoader");
  }

  return (
    <BaseContainer maxWidth="lg">
    <BoxTemplate1 height="80vh" title="Import CSV" >
      <FormProvider {...methods}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <FormInput
              variant="filled"
              InputProps={{
                readOnly: true,
              }}
              hidden
              name="LOAD_ID"
              label="Load Id"
            />
          </Grid>
          <Grid item xs={12}>
            <MuiSelect
              name="HOST_NAME"
              label="Host Name"
              options={listHost}
              errorobj={errors}
              required
              onChange={handleHostChange}
              value={hostKey}
            />
          </Grid>
          <Grid item xs={12}>
            <MuiSelect
              name="TOPIC_ID"
              label="Load Topic"
              options={listTopicType}
              errorobj={errors}
              required
              onChange={handleTopicChange}
              value={topic}
            />
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" className="browseFile">
              <FormInput
                disabled
                name="FILE_NAME"
                label="Source File"
                InputLabelProps={{
                  shrink: true,
                }}
                value={file?.path || ""}
              />
              <Button
                variant="contained"
                onClick={() => {
                  setOpen(true);
                }}
              >
                Browse
              </Button>
            </Box>
          </Grid>
          {listColumn.map((x, i) => {
            return (
              <Grid item xs={12} key={"COLUMN_" + i}>
                <Box className="columnAdd">
                  <Box display="flex" width="100%">
                    <FormInput
                      name={x.COLUMN}
                      variant="filled"
                      label={"Column : " + (i + 1)}
                      value={x.COLUMN}
                      onChange={(e) => handleChange(e, i)}
                    />
                    <MuiSelect
                      name={"ENCRYPT_ID"}
                      label={"Encrypt : " + (i + 1)}
                      options={listEncryptMap}
                      value={x.ENCRYPT_ID}
                      onChange={(e) => handleChange(e, i)}
                    />
                  </Box>
                </Box>
              </Grid>
            );
          })}
          <Grid item xs={12}>
            {loading && <LinearProgress />}
            {loading && <LinearProgress color="secondary" />}
          </Grid>
          <Grid item xs={12}>
            <Box className="buttonEvent">
              <Button
                variant="contained"
                onClick={Submit}
                disabled={loading && true}
              >
                Submit
              </Button>
              <Button variant="contained" onClick={CloseScreen}>
                Cancel
              </Button>
            </Box>
          </Grid>
        </Grid>
        <DropzoneDialog
          acceptedFiles={[".csv, text/csv, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values"]}
          cancelButtonText={"cancel"}
          filesLimit={1}
          submitButtonText={"submit"}
          maxFileSize={52428800}
          open={open}
          onClose={() => setOpen(false)}
          onSave={(files) => {
            upload(files);
            setOpen(false);
          }}
          showPreviews={true}
          showFileNamesInPreview={true}
        />
      </FormProvider>
      </BoxTemplate1>
    </BaseContainer>
  );
}

export default UploadScreen;
